import TieupImg from "../../common/TieupImg"
import { fetchUserAppeal } from "src/models/user/fetchUserAppeal"
import { ApiUserData } from "src/models/user/ApiUserData"
import useSWR from "swr"
import nl2br from "react-nl2br"
import styles from "./GiftingAppeal.module.scss"
import { SizeType } from "../../common/TieupImg/SizeType"

type Props = {
  user: ApiUserData
}

const GiftingAppeal: React.FC<Props> = ({ user }) => {
  const { data: userAppeal } = useSWR(
    `/v1/user/${user.id}/appeal`,
    () => fetchUserAppeal(user.id),
    { revalidateOnMount: true, revalidateOnFocus: false },
  )

  if (!userAppeal?.appealComment) return null

  return (
    <div className={styles.pr}>
      <div className={styles.pr_userIcon}>
        <TieupImg
          src={user.icon_url || "/img/user-icon.png"}
          alt={user.display_name}
          size={SizeType.s}
        />
      </div>
      <div className={styles.pr_body}>
        <p className={styles.pr_body_p}>{nl2br(userAppeal.appealComment)}</p>
      </div>
    </div>
  )
}

export default GiftingAppeal
